/* global jQuery */

import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import classNames from 'classnames';

import WaitTime from './WaitTime';

import JobLog from './Log';
import JobArtifacts from './Artifacts';
import JobTimeline from './Timeline';
import JobActivityTimeline from 'app/components/JobActivityTimeline';
import JobEnvironment from './Environment';

import Duration from 'app/components/shared/Duration';
import Emojify from 'app/components/shared/Emojify';
import Icon from 'app/components/shared/Icon';
import RemoteButtonComponent from 'app/components/shared/RemoteButtonComponent';
import UserAvatar from 'app/components/shared/UserAvatar';

import jobCommandOneliner from 'app/lib/jobCommandOneliner';
import LegacyDispatcher from 'app/lib/legacyDispatcher';
import parseEmoji from 'app/lib/parseEmoji';
import { getRelativeDateString } from 'app/lib/date';
import { jobTime } from 'app/lib/jobs';

import BuildPageStore from 'app/stores/BuildPageStore';

export const elementIdFor = (jobId) => `job-${jobId}`;

/* eslint-disable react/prefer-es6-class */
// TODO: Move to a class

export default createReactClass({
  displayName: "Job",

  propTypes: {
    className: PropTypes.string,
    build: PropTypes.object.isRequired,
    job: PropTypes.shape({
      id: PropTypes.string.isRequired,
      state: PropTypes.string.isRequired,
      passed: PropTypes.bool.isRequired,
      command: PropTypes.string.isRequired,
      name: PropTypes.string,
      basePath: PropTypes.string.isRequired,
      agentName: PropTypes.string,
      artifactCount: PropTypes.number,
      parallelGroupTotal: PropTypes.number,
      parallelGroupIndex: PropTypes.number,
      cancelable: PropTypes.shape({
        allowed: PropTypes.bool.isRequired
      }),
      retryable: PropTypes.shape({
        allowed: PropTypes.bool.isRequired,
        message: PropTypes.string
      }).isRequired,
      retriedInJobUuid: PropTypes.string,
      retriedBy: PropTypes.shape({
        name: PropTypes.string.isRequired,
        avatarUrl: PropTypes.string.isRequired
      }),
      startedAt: PropTypes.string,
      agentAssignedAt: PropTypes.string,
      agentAcceptedAt: PropTypes.string,
      retriedAt: PropTypes.string,
      runnableAt: PropTypes.string,
      canceledAt: PropTypes.string,
      finishedAt: PropTypes.string,
      timedOutAt: PropTypes.string,
      permissions: PropTypes.shape({
        retry: PropTypes.shape({
          allowed: PropTypes.bool.isRequired,
          message: PropTypes.string,
          reason: PropTypes.string
        }).isRequired
      }).isRequired
    }).isRequired
  },

  tabs() {
    return [
      {
        id: "output",
        name: "Log",
        component: JobLog
      },
      {
        id: "artifacts",
        name: "Artifacts",
        count: this.props.job.artifactCount,
        component: JobArtifacts
      },
      {
        id: "agent",
        name: "Timeline",
        component: JobTimeline
      },
      (Features.JobActivity ? ({
        id: "timeline",
        name: "Timeline ✨",
        component: JobActivityTimeline
      }) : null),
      {
        id: "env",
        name: "Environment",
        component: JobEnvironment
      }
    ].filter(Boolean);
  },

  notifyStoreOfRender() {
    if (this.state.expanded) {
      // Trigger the action in the next execution thread because there's a high
      // chance that this method was called as part of a dispatch and we don't
      // want to cause a loop
      setTimeout(
        () => (
          LegacyDispatcher.emit(
            "job:expanded",
            {
              job: this.props.job,
              el: this.wrapperNode
            }
          )
        ),
        0
      );
    }
  },

  getInitialState() {
    return {
      tab: "output",
      expanded: this.suggestedExpandedState()
    };
  },

  // Some magic to determine the default expanded state for the job.
  suggestedExpandedState() {
    return BuildPageStore.isJobExpanded(this.props.job);
  },

  componentDidMount() {
    BuildPageStore.addChangeListener(this.props.job, this._onStoreChange);
    this.notifyStoreOfRender();
  },

  componentWillUnmount() {
    BuildPageStore.removeChangeListener(this.props.job, this._onStoreChange);
  },

  componentDidUpdate() {
    this.notifyStoreOfRender();
  },

  _onStoreChange() {
    const expanded = BuildPageStore.isJobExpanded(this.props.job);

    // If we're changing from expanded to not exapnded, and the wrapping
    // element is outside the viewport (meaning the header is likely stickied
    // to the top of it), scroll to the top of the element so it stays in view
    // when it collapses. This is for Sticky Job Headers, but shouldn't change
    // much of note about the page's behaviour when that isn't enabled.
    if (this.state.expanded && !expanded &&
        this.wrapperNode.offsetTop < window.scrollY) {
      this.wrapperNode.scrollIntoView();
    }

    this.setState({ expanded });
  },

  scrollToAndExpandJob() {
    this.setState({ expanded: true }, () => {
      this.scrollToJob();
    });
  },

  scrollToJob() {
    const $anchor = jQuery(this.wrapperNode);
    jQuery(window).scrollTop($anchor.offset().top);
  },

  icon(job) {
    if (job.softFailed) {
      return "fa fa-exclamation-triangle";
    }

    switch (job.state) {
      case "pending": return "fa fa-clock-o";
      case "waiting": return "fa fa-clock-o";
      case "waiting_failed": return "fa fa-clock-o";
      case "blocked": return "fa fa-lock";
      case "blocked_failed": return "fa fa-lock";
      case "unblocked": return "fa fa-unlock";
      case "unblocked_failed": return "fa fa-unlock";
      case "limited": return "fa fa-clock-o";
      case "scheduled": return "fa fa-clock-o";
      case "assigned": return "fa fa-clock-o";
      case "accepted": return "fa fa-clock-o";
      case "skipped": return "fa fa-minus-square";
      case "running":
      case "canceling":
      case "timing_out":
        return "fa fa-refresh fa-spin";
      case "finished":
      case "timed_out":
      case "canceled":
        if (job.passed) {
          return "fa fa-check";
        }
        return "fa fa-times";
    }
  },

  handleTabClick(tab) {
    return (event) => {
      this.setState({ tab });
      event.preventDefault();
    };
  },

  handleClickHeader(evt) {
    // return if the user did a middle-click, right-click, or used a modifier
    // key (like ctrl-click, meta-click, shift-click, etc.)
    if ((evt.button !== 0) || evt.altKey || evt.ctrlKey || evt.metaKey || evt.shiftKey) {
      return;
    }

    evt.preventDefault();

    LegacyDispatcher.emit("job:toggle", { job: this.props.job });
  },

  handleClickRetriedJobLink(evt) {
    // return if the user did a middle-click, right-click, or used a modifier
    // key (like ctrl-click, meta-click, shift-click, etc.)
    if ((evt.button !== 0) || evt.altKey || evt.ctrlKey || evt.metaKey || evt.shiftKey) {
      return;
    }

    LegacyDispatcher.emit("job:retried-link-click", { job: this.props.job });
  },

  tabMenuNodes() {
    return this.tabs().map((tab) => {
      let className = "btn btn-tab btn-tab--compact btn-tab--monochrome";

      if (this.state.tab === tab.id) {
        className += " btn-tab--active";
      }

      if (tab.count) {
        className += " btn-tab--badged";
      }

      return (
        <li key={tab.id}>
          {this._renderTabLink(tab, className)}
        </li>
      );
    });
  },

  _renderTabLink(tab, className) {
    return (
      <button className={className} onClick={this.handleTabClick(tab.id)}>
        {tab.name}
        {this._renderTabCount(tab)}
      </button>
    );
  },

  _renderTabCount(tab) {
    if (tab.count) {
      return (
        <span className="badge badge--outline ml1 tabular-numerals">
          {tab.count}
        </span>
      );
    }
  },

  tabContentNodes() {
    return this.tabs().map((tab) => {
      let className = "tab-pane";

      if (this.state.tab === tab.id) {
        className += " active";
        const contents = (
          <tab.component
            build={this.props.build}
            job={this.props.job}
            parentElementId={this.elementId()}
          />
        );
        return (
          <div key={tab.id} className={className}>
            {contents}
          </div>
        );
      }
    });
  },

  parallelInfoNode() {
    if (this.props.job.parallelGroupTotal && (this.props.job.parallelGroupTotal > 1)) {
      const text = `${this.props.job.parallelGroupIndex + 1}/${this.props.job.parallelGroupTotal}`;
      return (
        <div
          className="flex items-center rounded dark-gray border border-gray small relative tabular-numerals px1"
          style={{ "lineHeight": 1.75 }}
        >
          {text}
        </div>
      );
    }
  },

  commandNode() {
    if (this.props.job.command) {
      return (
        <span
          className="small dark-gray monospace truncate mr1"
          style={{ flex: "0 1 auto" }}
        >
          {jobCommandOneliner(this.props.job.command)}
        </span>
      );
    }
  },

  jobNameNode() {
    if (this.props.job.name) {
      return (
        <span
          className="truncate mr1"
          style={{ flex: "0 0 auto" }}
          data-testid="JobName"
          dangerouslySetInnerHTML={{ __html: parseEmoji(this.props.job.name) }}
        />
      );
    }
  },

  elementId() {
    return elementIdFor(this.props.job.id);
  },

  renderRetryJobButton() {
    // Before attempting to render the button, we'll see if we've already
    // retried this job, and if we have, render who did it and when.
    let retryNotAllowedMessage;
    if (this.props.job.retriedInJobUuid) {
      const linkContents = (
        this.props.job.retriedBy
          ? (
            <React.Fragment>
              <UserAvatar
                user={{ name: this.props.job.retriedBy.name, avatar: { url: this.props.job.retriedBy.avatarUrl } }}
                className="mr1"
                style={{
                  width: 20,
                  height: 20
                }}
                suppressAltText={true}
              />
              <span className="semi-bold">
                {this.props.job.retriedBy.name}
              </span>
              {`\u00A0retried ${getRelativeDateString(this.props.job.retriedAt)}`}
            </React.Fragment>
          )
          : (
            <React.Fragment>
              <Icon
                icon="retry"
                style={{
                  width: 14,
                  height: 14,
                  position: "relative",
                  top: -1,
                  marginRight: 3
                }}
              />
              Automatically retried {getRelativeDateString(this.props.job.retriedAt)}
            </React.Fragment>
          )
      );

      return (
        <a
          href={window.location.pathname + `#${this.props.job.retriedInJobUuid}`}
          onClick={this.handleClickRetriedJobLink}
          className="mt1 text-decoration-underline black hover-black flex items-center block"
          style={{ height: 24, fontSize: 13 }}
        >
          {linkContents}
        </a>
      );
    }

    // We never want to show the retry button if the current user is anonymous,
    // so we'll just bail out early here and return nothing.
    if (this.props.job.permissions.retry.reason === "anonymous") {
      return null;
    }

    // Don't show the retry button if it's not finished.
    if ((this.props.job.state !== "finished") && (this.props.job.state !== "timed_out") && (this.props.job.state !== "canceled")) {
      return null;
    }

    // Also don't show the retry button if the job has "passed" and there isn't
    // an error message (we may want to show the retry button for failed jobs if
    // the user has configured it to be allowed)
    if (this.props.job.passed && !this.props.job.retryable.allowed) {
      return null;
    }

    // First check if we're allowed to retry based on permissions. If we're
    // all good on that front, check to see if the job is eligible for
    // retries.
    if (!this.props.job.permissions.retry.allowed) {
      retryNotAllowedMessage = this.props.job.permissions.retry.message;
    } else if (!this.props.job.retryable.allowed) {
      retryNotAllowedMessage = this.props.job.retryable.message;
    }

    const retryButtonContent = (
      <React.Fragment>
        <Icon
          icon="retry"
          style={{
            width: 14,
            height: 14,
            position: "relative",
            top: -1,
            marginRight: 3
          }}
        />
        Retry
      </React.Fragment>
    );

    if (retryNotAllowedMessage) {
      // Retries are disabled, let's render a disabled button with a tooltip for more info!
      return (
        <button
          disabled={true}
          className="btn btn-default"
          aria-label={retryNotAllowedMessage}
          style={{ fontSize: 13, height: 34, lineHeight: "13px" }}
        >
          {retryButtonContent}
        </button>
      );
    }

    const options = {
      url: (this.props.job.basePath + "/retry"),
      method: "post",
      loadingText: "Retrying...",
      className: "btn btn-default",
      style: { fontSize: 13, height: 34, lineHeight: "13px" }
    };

    if (!BuildPageStore.isNewRetriesEnabled()) {
      options["confirmText"] = "Retrying will discard this job’s log and artifacts";
    }

    // Retries are all good! Let's render the button.
    return (
      <RemoteButtonComponent {...options}>
        {retryButtonContent}
      </RemoteButtonComponent>
    );

  },

  renderCancelJobButton() {
    if (!BuildPageStore.isNewRetriesEnabled()) {
      return null;
    }

    const options = {
      url: this.props.job.basePath + "/cancel",
      method: "post",
      loadingText: "Cancelling...",
      className: "btn btn-default",
      style: { fontSize: 13, height: 34, lineHeight: "13px" }
    };

    if (this.props.job.state === "canceling") {
      // If the job is already canceling, force the `loading` state on the
      // button
      options["loading"] = true;
    } else if (!this.props.job.cancelable.allowed) {
      // Don't render the cancel button if it can't be cancelled
      return null;
    }

    return (
      <RemoteButtonComponent {...options}>
        <i className="fa fa-times mr1" />
        Cancel
      </RemoteButtonComponent>
    );
  },

  render() {
    let jobContentNode;

    let state = (
      this.props.job.state === 'finished' ||
      this.props.job.state === 'timed_out' ||
      this.props.job.state === 'canceled'
        ? (
          this.props.job.passed
            ? 'passed'
            : 'failed'
        )
        : this.props.job.state
    );

    // Cancelling and timing out are still running, so let's show them as such.
    if (state === 'canceling' || state === 'timing_out') {
      state = 'running';
    }

    const iconClassName = `mr1 build-details-pipeline-icon ${this.icon(this.props.job)}`;

    const jobRetryGroupFirst = (
      this.props.className
        && this.props.className.indexOf('job-retry-group-first') !== -1
    );

    const jobRetryGroupMiddle = (
      this.props.className
        && this.props.className.indexOf('job-retry-group-middle') !== -1
    );

    const jobRetryGroupLast = (
      this.props.className
        && this.props.className.indexOf('job-retry-group-last') !== -1
    );

    const jobRetryGroup = jobRetryGroupFirst || jobRetryGroupMiddle || jobRetryGroupLast;

    // If we're going to expand and we haven't rendered
    // the job content node before. This small hack lets us lazily
    // load the tabs.
    if (this.state.expanded && !this.lazyLoaded) {
      this.lazyLoaded = true;
    }

    // If it's been lazy loaded, we can start generating the content
    if (this.lazyLoaded) {
      jobContentNode = (
        <div
          className={classNames(
            'build-details-pipeline-job-body',
            {
              'rounded-bottom': !jobRetryGroupFirst && !jobRetryGroupMiddle
            }
          )}
        >
          <div className="build-details-pipeline-job-body__controls py2 bg-white z1">
            <div className="absolute" style={{ top: 8, right: 0 }}>
              {this.renderRetryJobButton()}
              {this.renderCancelJobButton()}
            </div>
            <ul
              className="monochrome flex list-style-none p0 m0 border-bottom border-gray"
              style={{ fontSize: 13 }}
            >
              {this.tabMenuNodes()}
            </ul>
          </div>
          <div className="tab-content">
            {this.tabContentNodes()}
          </div>
        </div>
      );
    }

    const specialStateNode = this.specialStateNode();
    let extraStatusNode;
    if (specialStateNode) {
      extraStatusNode = (
        <div className="flex-none xs-hide">
          {specialStateNode}
        </div>
      );
    }

    return (
      <div
        className={classNames(
          'build-details-pipeline-job relative',
          {
            [`build-details-pipeline-job-state-${state}`]: true,
            'build-details-pipeline-job-expanded': this.state.expanded
          },
          this.props.className
        )}
        id={this.elementId()}
        ref={(wrapperNode) => this.wrapperNode = wrapperNode}
      >
        <a
          className={classNames(
            "build-details-pipeline-job__header flex p3 items-center cursor-pointer color-inherit focus-color-inherit hover-color-inherit focus-bg-silver hover-bg-silver bg-white text-decoration-none z2",
            {
              'rounded': (
                !jobRetryGroup
                  && !this.state.expanded
              ),
              'rounded-bottom': (
                jobRetryGroup
                  && jobRetryGroupLast
                  && !this.state.expanded
              ),
              'rounded-top': (
                jobRetryGroupFirst
                  || (jobRetryGroupLast && !this.state.expanded)
                  || (!jobRetryGroup && this.state.expanded)
              )
            }
          )}
          href={window.location.pathname + `#${this.state.expanded ? '_' : this.props.job.id}`}
          onClick={this.handleClickHeader}
        >
          <i className={iconClassName} />
          <div className="flex-none mr1">
            {this.parallelInfoNode()}
          </div>
          <div className="flex flex-auto items-center mr1">
            {this.jobNameNode()}
            {this.commandNode()}
          </div>
          {extraStatusNode}
          <div className="flex-none">
            {this.durationNode()}
          </div>
          <div className="flex-none xs-hide">
            {this.waitNode()}
          </div>
          <div className="flex-none xs-hide">
            {this.agentNode()}
          </div>
        </a>
        {jobContentNode}
      </div>
    );
  },

  agentNode() {
    if (this.props.job.agentName) {
      return (
        <div className="flex flex-auto items-center dark-gray pl2 max-width-1 cursor-hand" title={this.props.job.agentName}>
          <i className="fa fa-cube mr1" />
          <Emojify text={this.props.job.agentName} className="truncate" />
        </div>
      );
    }
  },

  waitNode() {
    // Hide on jobs that aren't yet runnable,
    // or are either blocked or waiting
    if (!this.props.job.runnableAt ||
        (this.props.job.state === 'blocked') ||
        (this.props.job.state === 'waiting') ||
        (this.props.job.state === 'waiting_failed')) {
      return;
    }

    // Return a version that doesn't include the timer if it's been skipped
    if (this.props.job.state === "skipped") {
      return (
        <div className="dark-gray pl2">
          <span>
            Skipped
          </span>
        </div>
      );
    }

    const props = (
      this.props.job.state === 'scheduled'
        ? {
          label: "Waiting for agent",
          from: this.props.job.runnableAt,
          to: this.props.job.startedAt
        }
        : (
          this.props.job.state === 'limited'
            ? {
              label: "Waiting on concurrency group",
              from: this.props.job.runnableAt,
              to: this.props.job.startedAt
            }
            : (
              !this.props.job.agentAcceptedAt && (this.props.job.state !== 'canceled')
                ? {
                  label: "Waiting to accept",
                  from: this.props.job.agentAssignedAt
                }
                : {
                  label: "Waited",
                  from: this.props.job.runnableAt,
                  to: this.props.job.startedAt || this.props.job.canceledAt
                }
            )
        )
    );

    return <WaitTime {...props} />;
  },

  specialStateNode() {
    let text = null;

    if (this.props.job.state === 'canceled') {
      text = "Canceled";
    } else if (this.props.job.state === 'canceling') {
      text = "Canceling…";
    } else if (this.props.job.state === 'timed_out') {
      text = "Timed Out";
    } else if (this.props.job.state === 'timing_out') {
      text = "Timing Out…";
    }

    if (text) {
      return (
        <div className="dark-gray pl2">
          <i className="fa fa-warning mr1" />
          <span>{text}</span>
        </div>
      );
    }

    return null;
  },

  durationNode() {
    if (this.props.job.startedAt) {
      const runTense = (
        this.props.job.state === 'running'
          ? "Running for"
          : "Ran in"
      );

      const duration = jobTime({
        state: this.props.job.state.toUpperCase(),
        startedAt: this.props.job.startedAt,
        finishedAt: this.props.job.finishedAt,
        canceledAt: this.props.job.canceledAt,
        timedOutAt: this.props.job.timedOutAt
      });

      return (
        <div className="dark-gray pl2">
          <i className="fa fa-clock-o mr1" />
          <span>
            {runTense}
            {" "}
            <Duration.Short {...duration} />
          </span>
        </div>
      );
    }
  }
});
